<div class="resource-profile-container">
	<div style="display: flex; justify-content: space-between; align-items: start;">
		<app-title-field [title]="'Resource Profile Page'"></app-title-field>
		<div class="close-button" (click)="closeForm()">
			<app-title-field [icon]="'close'" [title]="' '"></app-title-field>
		</div>
	</div>
	<form [formGroup]="form">
		<!-- Resource Information Section -->
		<div class="section">
			<br>
			<div class="section-title">Resource Information</div><br>
			<div class="resource-info-grid">
				<div class="resource-info-row even-cols">
					<app-input-field label="Resource Name" [disabled]="true" [type]="'text'"
						formControlName="fullName"></app-input-field>
					<app-input-field label="PS ID" [disabled]="true" [type]="'text'"
						formControlName="employeeId"></app-input-field>
					<app-input-field label="Email ID" [disabled]="true" [type]="'email'"
						formControlName="email"></app-input-field>
				</div>
				<div class="resource-info-row even-cols">
					<app-input-field label="Company" [type]="'text'" formControlName="employer"></app-input-field>
					<mat-form-field class="form-input" appearance="outline" floatLabel="always">
						<mat-label>Date of Joining</mat-label>
						<input matInput [matDatepicker]="pickerLastHireDate" formControlName="lastHireDate"
							placeholder="MM/DD/YYYY">
						<mat-datepicker-toggle matIconSuffix [for]="pickerLastHireDate"
							[disableRipple]="true"></mat-datepicker-toggle>
						<mat-datepicker #pickerLastHireDate></mat-datepicker>
					</mat-form-field>
					<app-input-field label="Location" [type]="'text'" formControlName="location"></app-input-field>
				</div>
				<div class="resource-info-row even-cols">
					<app-input-field label="Reporting Manager" [type]="'text'"
						formControlName="reportingManager"></app-input-field>
					<app-input-field label="D&T Leader" [type]="'text'" formControlName="dntLeader"></app-input-field>
					<div></div>
				</div>
			</div>
		</div>

		<!-- Asset & Accessories Information Section -->
		<!-- <hr class="section-divider" /> -->
		<div class="section">
			<div class="section-title">Asset & Accessories Information</div><br>
			<div class="asset-info-grid" *ngIf="!isLoading">
				<div class="asset-info-row even-cols">
					<app-dropdown class="emerald-dropdown dropdown-cls" [options]="laptopOptions" [label]="'Laptop'"
						[outlined]="true" [displayKey]="'label'" [valueKey]="'value'" [disabled]="true"
						formControlName="laptopType" [disabled]="true"></app-dropdown>

					<app-input-field label="Laptop Serial Number" type="text"
						formControlName="laptopSerialNumber"></app-input-field>
					<app-input-field label="Charger Serial Number" type="text"
						formControlName="chargerSerialNumber"></app-input-field>
				</div>
				<div class="asset-info-row even-cols">
					<app-dropdown class="emerald-dropdown dropdown-cls" [options]="accessoryOptions"
						[label]="'Accessories Type'" [outlined]="true" [multiSelect]="true" [displayKey]="'label'"
						[valueKey]="'value'" formControlName="accessoriesType" [disabled]="true">
					</app-dropdown>

				</div>
			</div>
			<mat-expansion-panel>
				<mat-expansion-panel-header>
					<div class="section-title">History of Asset & Accessories Information</div>
				</mat-expansion-panel-header>
				<ng-container class="mat-expansion-panel-body" *ngIf="hasAssetHistory; else noAssetHistory"
					style="padding: 0px;">
					<div class="table-card" *ngIf="historyData.length">
						<table class="history-table">
							<thead>
								<tr>
									<th *ngFor="let field of historyFields">{{ field.label }}</th>
									<th>Last Updated</th>
									<th>Recieved Status</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let item of historyData; let i = index">
									<td *ngFor="let field of historyFields">{{ item[field.value] }}</td>
									<td>{{ item?.lastHireDate || 'No date available' }}</td>
									<td class="return-status-cell">
										<app-status-label
												[showDropdown]="true"
												[category]="'assetType'"
												[statusV]="item?.returnStatus || 'Pending'"
												[readonly]="item?.returnStatus === 'Done'"
												(statusChange)="onStatusChanged($event)"></app-status-label>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</ng-container>
				<ng-template #noAssetHistory>
					<div class="no-data">No data available</div>
				</ng-template>
			</mat-expansion-panel>
		</div>
		<hr class="section-divider" />
	</form>
</div>